// General Loggers and Trackers
import firebase from "../firebase"
import type { LastUpdate, AcComment } from "../types/application";
import { addSingleArrayItem } from "../mixins/modularFirebaseOperations";

export const trackLastUpdate = async (path: string, lastUpdate: LastUpdate) => {
    const docRef = firebase.firestore().doc(path)
    try {
        await docRef.update({
            updatedAt: lastUpdate
        })
    } catch (error) {
        console.error("Error updating last update: ", error);
        alert(`Bir hata oluştu: ${error}`);
    }
}

/* The Add Visible Log function just adds a 'comment' or 'update' to the current document.
It's basic function is logging, but it also displays the 'log' in the UI for it to be visible to all users.
It can be used for a document that has comments as a sub-collection or as an array field.
*/

export const addVisibleLog = async (path: string, id: string, logMessage: string, isArray?: boolean, fieldName?: string) => {
    const logObject: AcComment = {
        date: new Date(),
        comment: logMessage,
        isAutomatic: true
    }

    try{
        if (isArray) {
            await addSingleArrayItem(`${path}/${id}`, fieldName!, logObject)
        } else {
            const logRef = firebase.firestore().collection(path)
            await logRef.add(logObject)
        }
    } catch (error) {
        console.error("Error adding visible log: ", error);
        alert(`Bir hata oluştu: ${error}`);
    }
}

// CRM Loggers and Trackers


